import { routes } from '~/config/routes';
import { CurrentUser } from '~/types';
import { StripeAccountStatus, UserState } from '~/types/graphql';

export const getSelfServiceOnboardingRoute = (user: CurrentUser): string | undefined => {
  if (user.state !== UserState.RegistrationPending) {
    return undefined;
  }

  if (!user.emailVerifiedAt) {
    return routes.selfServiceSignUp.verifyEmail;
  }

  const workspace = user.roles[0]?.workspace;

  if (!workspace) {
    return routes.selfServiceSignUp.nonprofit;
  }

  if (
    workspace.needsStripeAccount ||
    workspace.stripeAccountStatus !== StripeAccountStatus.Connected
  ) {
    return routes.selfServiceSignUp.stripe;
  }

  return undefined;
};

export const isSelfServiceOnboardingRoute = (pathname: string, expectedRoute: string): boolean => {
  if (expectedRoute === routes.selfServiceSignUp.stripe) {
    return (
      pathname.startsWith(routes.selfServiceSignUp.stripe) ||
      pathname === routes.oauth.selfServiceStripe
    );
  }

  return pathname === expectedRoute;
};
